<template>
  <div>
    <payment-method-component
      :is="getPaymentComponent"
      :disabled="disabled"
      :confirmFailed="confirmFailed"
      :reserveInProgress="reserveInProgress"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PaymentMethodMastercard from './PaymentDetailsMastercard.vue'
import PaymentMethodBraintree from './PaymentDetailsBraintree.vue'
import PaymentMethodWindcave from './PaymentDetailsWindcave.vue'
import PaymentMethodSharedPayment from './PaymentDetailsSharedPayment.vue'

export default {
    name: 'PaymentMethod',
    components: {
        PaymentMethodBraintree,
        PaymentMethodMastercard,
        PaymentMethodWindcave,
        PaymentMethodSharedPayment
    },
    props: ['disabled', 'confirmFailed', 'reserveInProgress'],
    computed: {
        ...mapState({
            paymentProvider: state => state.booking.bookingReserveResponse.data.paymentProvider
        }),
        getPaymentComponent: function () {
            // Payment provider component template:'payment-method-[TenantConfig.PaymentProvider]
            return `payment-method-${this.paymentProvider}`
        }
    }
}
</script>
